import { defineMessages } from 'react-intl';

export const chatTogglerMessages = defineMessages({
	tooltip_active: {
		id: 'chat_toggler.active.tooltip',
		defaultMessage: 'Open chat',
		description: 'tooltip shown when mouse is over the active toggler',
	},
	tooltip_inactive: {
		id: 'chat_toggler.inactive.tooltip',
		defaultMessage: 'Chat offline',
		description: 'Tooltip shown when mouse is over the inactive toggler',
	},
});
